import { Subject } from 'rxjs';

const entitySaveCompletedSubject = new Subject<void>();

export const entitySaveCompleted$ = entitySaveCompletedSubject.asObservable();

export function entitySaveCompleted(): void {
    entitySaveCompletedSubject.next();
}
